import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-fixed-round-button',
  imports: [],
  templateUrl: './fixed-round-button.component.html',
  styleUrl: './fixed-round-button.component.css'
})
export class FixedRoundButtonComponent {
  @Input() title!: string;
  @Output() onClick = new EventEmitter();
}
